export default __webpack_public_path__ + "static/media/plain-sticker-9.e0127b79.png";